import { ChangeEvent, useState } from "react";
import { QuestionMarkCircleIcon, TextInput } from "@datagame/ui";
import { useTranslation } from "react-i18next";

import { SliderInput } from "../ui/SliderInput";
import { TooltipWithIcon } from "../ui/TooltipWithIcon";
import { Section } from "../../project/ProjectView/ProjectSettings/Steps/Common";

import styles from "./ScaleQuestionSectionTemplate.module.scss";

export interface RatingQuestionConfig {
  question: string;
  rightLabel: string;
  leftLabel: string;
  scaleSize: number;
}

export interface ScaleQuestionSectionTemplateProps {
  onChange: (config: RatingQuestionConfig) => void;
  value: RatingQuestionConfig;
}

export const ScaleQuestionSectionTemplate = (props: ScaleQuestionSectionTemplateProps) => {
  const { onChange, value } = props;
  const { t } = useTranslation();

  const [ratingQuestion, setRatingQuestion] = useState<string>(value.question);
  const [ratingRightLabel, setRatingRightLabel] = useState<string>(value.rightLabel);
  const [ratingLeftLabel, setRatingLeftLabel] = useState<string>(value.leftLabel);
  const [ratingScaleSize, setRatingScaleSize] = useState<number>(value.scaleSize);

  const handleSave = () => {
    onChange({
      question: ratingQuestion,
      rightLabel: ratingRightLabel,
      leftLabel: ratingLeftLabel,
      scaleSize: ratingScaleSize,
    });
  };

  return (
    <>
      <Section
        title={t("quickrank:ratingQuestion")}
        className={styles.sectionHeader}
        tooltip={<TooltipWithIcon content={t("wordopolis:ratingQuestionTooltip")} />}
      >
        <TextInput
          icon={<QuestionMarkCircleIcon />}
          placeholder={t("quickrank:ratingQuestionPlaceholder") ?? ""}
          value={ratingQuestion || ""}
          onChange={(e: ChangeEvent<HTMLInputElement>) => setRatingQuestion(e.target.value)}
          onBlur={handleSave}
          size="small"
          className={styles.input}
        />
      </Section>

      <Section
        title={t("quickrank:ratingScaleSize")}
        className={styles.sectionHeader}
        tooltip={<TooltipWithIcon content={t("wordopolis:ratingScaleSizeTooltip")} />}
      >
        <SliderInput
          className={styles.slider}
          min={2}
          max={10}
          value={ratingScaleSize}
          onBlur={handleSave}
          onChange={(e: ChangeEvent<HTMLInputElement>) => setRatingScaleSize(parseInt(e.target.value))}
        />
      </Section>

      <Section
        title={t("quickrank:ratingLeftLabel")}
        className={styles.sectionHeader}
        tooltip={<TooltipWithIcon content={t("wordopolis:ratingLeftLabelTooltip")} />}
      >
        <TextInput
          icon={<QuestionMarkCircleIcon />}
          placeholder={t("quickrank:ratingLeftLabelPlaceholder") ?? ""}
          value={ratingLeftLabel || ""}
          onChange={(e: ChangeEvent<HTMLInputElement>) => setRatingLeftLabel(e.target.value)}
          onBlur={handleSave}
          size="small"
          className={styles.input}
        />
      </Section>

      <Section
        title={t("quickrank:ratingRightLabel")}
        className={styles.sectionHeader}
        tooltip={<TooltipWithIcon content={t("wordopolis:ratingRightLabelTooltip")} />}
      >
        <TextInput
          icon={<QuestionMarkCircleIcon />}
          placeholder={t("quickrank:ratingRightLabelPlaceholder") ?? ""}
          value={ratingRightLabel || ""}
          onChange={(e: ChangeEvent<HTMLInputElement>) => setRatingRightLabel(e.target.value)}
          onBlur={handleSave}
          size="small"
          className={styles.input}
        />
      </Section>
    </>
  );
};
